<template>
  <div>
    <!-- Barra de búsqueda -->
    <div class="card shadow-sm mb-4 mt-2">
      <div class="card-header bg-light fw-bold">
        <span class="material-icons align-middle me-1" style="font-size:18px">folder_copy</span>
        Consulta de otras atenciones de {{ nombre }}
      </div>
      <div class="card-body">
        <div class="row g-3 align-items-end">
          <div class="col-md-4">
            <label class="form-label small fw-bold">Tipo de consulta</label>
            <select
              v-model="consultaSeleccionada"
              class="form-select"
              @change="buscar"
            >
              <option value="1">Por número de cédula</option>
              <option value="2">Por cédula y especialidad</option>
            </select>
          </div>

          <div class="col-md-8 d-flex align-items-center">
            <div v-if="registros.length > 0" class="text-muted small">
              <span class="material-icons align-middle" style="font-size:14px;color:#198754">check_circle</span>
              {{ registros.length }} planilla{{ registros.length !== 1 ? 's' : '' }} encontrada{{ registros.length !== 1 ? 's' : '' }}
              para <strong>{{ cedula }}</strong>
            </div>

            <div v-else-if="buscado" class="text-muted small">
              <span class="material-icons align-middle" style="font-size:14px;color:#ffc107">info</span>
              No se encontraron planillas para <strong>{{ cedula }}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- DataTable -->
    <DataTable
      :data="registros"
      :columns="[
        { label: 'Id. Trámite',  field: 'idTramite' },
        { label: 'Cédula',       field: 'cedula' },
        { label: 'Número',       field: 'numero' },
        { label: 'Diag 1',       field: 'diag1' },
        { label: 'Diag 2',       field: 'diag2' },
        {
          label: 'Fecha desde',
          field: 'fechaDesde',
          format: (v) => getFormattedDate(v)
        },
        {
          label: 'Fecha hasta',
          field: 'fechaHasta',
          format: (v) => getFormattedDate(v)
        },
      ]"
      idField="idPlanilla"
      mensajeVacio="No hay planillas. Seleccione un tipo de consulta para ver resultados."
      :acciones="true"
      :mostrarEditar="false"
      :mostrarVer="false"
      :mostrarEliminar="false"
      :mostrarBotonTodos="false"
      :mostrarBotonNuevo="false"
      :mostrarBotonExcel="true"
    >
      <!-- Acción por fila -->
      <template #acciones-fila="{ row }">
        <button
          class="btn btn-sm btn-outline-info"
          @click="abrirPlanilla(row.idPlanilla)"
          title="Ver planilla"
        >
          <span class="material-icons" style="font-size:14px">open_in_new</span>
        </button>
      </template>
    </DataTable>

    <!-- Modal de la Planilla -->
    <PlanillaModal
      :idPlanilla="idPlanillaSeleccionada"
      @cerrar="cerrarPlanilla"
      v-show="mostrarPlanilla"
    />
  </div>
</template>

<script>
import api from '@/services/api';
import DataTable from '@/components/DataTable.vue';
import PlanillaModal from '@/components/PlanillaModal.vue';
import dateFormat from '@/modules/dateFormat.js';

export default {
  components: {
    DataTable,
    PlanillaModal,
  },

  props: {
    idPrestador: {
      type: Number,
      required: true,
    },
    idEspecialidad: {
      type: Number,
      required: false,
    },
    cedula: {
      type: String,
      required: true,
    },
    nombre: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      consultaSeleccionada: '1',
      registros: [],
      buscado: false,
      idPlanillaSeleccionada: null,
      mostrarPlanilla: false,
    };
  },

  mounted() {
    this.buscar();
  },

  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },

    async buscar() {
      try {
        let url = `/vwplanillatras/prestador/${this.idPrestador}/cedula/${this.cedula}`;

        if (this.consultaSeleccionada === '2' && this.idEspecialidad) {
          url = `/vwplanillatras/prestador/${this.idPrestador}/especialidad/${this.idEspecialidad}/cedula/${this.cedula}`;
        }

        const response = await api.get(url);
        const data = response.data;

        this.registros = Array.isArray(data)
          ? data
          : data
            ? [data]
            : [];

        this.buscado = true;
      } catch (error) {
        console.error('Error en la búsqueda:', error);
        this.registros = [];
        this.buscado = true;
      }
    },

    abrirPlanilla(idPlanilla) {
      this.idPlanillaSeleccionada = idPlanilla;
      this.mostrarPlanilla = true;
    },

    cerrarPlanilla() {
      this.mostrarPlanilla = false;
      this.idPlanillaSeleccionada = null;
    },
  },
};
</script>